<section class="flex flex-col gap-y-40">
  <div class="flex flex-col gap-y-8">
    <h1>{{ errorConfig.title | translate }}</h1>
    <span class="text-md font-semi-bold">
      {{ errorConfig.description | translate }}
    </span>
  </div>

  <tsq-button
    *ngIf="!loading; else loader"
    schema="new-primary"
    size="lg"
    [text]="errorConfig.nameButton | translate"
    (clicked)="handleClick()"
  />
  <ng-template #loader>
    <tsq-small-loader />
  </ng-template>
</section>
